export default {
    //是否是网页打开
    is_PC(state, is_PC) {
        state.is_PC = is_PC;
    },
    //是否微信登录
    updateIsWechat(state, is_wechat) {
        state.is_wechat = is_wechat;
    },
    //是否为IOS
    updateIsIos(state, is_ios) {
        state.is_ios = is_ios;
    },
    //修改登录跳转的页面
    updateLoginPage(state, login_page) {
        state.login_page = login_page;
    },
    //是否显示返回上一级
    updateIsReturn(state, is_return) {
        state.is_return = is_return;
    },
    //首页弹窗状态更改
    updateCenterDialogVisible(state, centerDialogVisible) {
        state.centerDialogVisible = centerDialogVisible;
    },
    //首页模态框类型
    updatemodalStatus(state, modalStatus) {
        state.modalStatus = modalStatus;
    },
    //滚轮状态
    updateScrollType(state, scrollType) {
        state.scrollType = scrollType;
    },
    //登录状态
    updateIsLogin(state, is_login) {
        state.is_login = is_login;
    },
    //用户资料页面当前选择菜单状态 userPage.vue
    update_user_nav_active(state, user_nav_active) {
        state.user_nav_active = user_nav_active;
    },
    //登录用户资料 index.vue
    update_login_user(state, login_user) {
        state.login_user = login_user;
    },
    //学员弹窗显示 babyModal.vue,
    update_babyModal_visible(state, babyModalVisible) {
        state.babyModalVisible = babyModalVisible
    },
    //学员弹窗表单 babyModal.vue
    update_babyModal_form(state, babyModalForm) {
        state.babyModalForm = babyModalForm
    },
    //报名弹窗
    update_courseEnterVisible(state, courseEnterVisible) {
        state.courseEnterVisible = courseEnterVisible
    },
    //修改学校信息资料
    update_schoolInformation(state, schoolInformation) {
        state.schoolInformation = schoolInformation
    },
    //修改搜索内容
    updateSearchVal(state, SearchVal) {
        state.SearchVal = SearchVal
    },
    //floatbar底部active状态页面
    updateFloatBarActive(state, floatBarActive) {
        state.floatBarActive = floatBarActive
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js